import React, { useRef, useEffect } from 'react';
import { tooltipCss, getListener } from '../utils';
import './Tooltip.scss';
export const Tooltip = ({ children, tip, className, overrideCss, dottedText, forEllipsesText, }) => {
    const { tooltipBlock, tooltipContent, tooltipTip } = tooltipCss({
        className,
        overrideCss,
        dottedText,
    });
    const tooltipRef = useRef(null);
    const wrapperRef = useRef(null);
    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (wrapperRef.current && tooltipRef.current) {
            const wrapper = wrapperRef.current;
            const mouseListener = getListener({
                isWrappedText: forEllipsesText,
                tooltipRef,
                wrapperRef,
            });
            wrapperRef.current.addEventListener('mousemove', mouseListener);
            return () => wrapper.removeEventListener('mousemove', mouseListener);
        }
    }, [wrapperRef, tooltipRef, forEllipsesText]);
    if (!tip) {
        return React.createElement(React.Fragment, null, children);
    }
    return (React.createElement("div", { ref: wrapperRef, className: tooltipBlock },
        React.createElement("div", { className: tooltipContent }, children),
        React.createElement("div", { ref: tooltipRef, className: tooltipTip }, tip)));
};
//# sourceMappingURL=Tooltip.js.map